import { render, staticRenderFns } from "./xsyl.vue?vue&type=template&id=a9c2f47e&scoped=true&"
import script from "./xsyl.vue?vue&type=script&lang=js&"
export * from "./xsyl.vue?vue&type=script&lang=js&"
import style0 from "./xsyl.vue?vue&type=style&index=0&id=a9c2f47e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c2f47e",
  null
  
)

export default component.exports